import LoadingPage from 'gcs-common/components/LoadingPage/LoadingPage';
import { getGccApiClientInit } from 'gcs-common/slices/gccApiConnection/gccApiConnectionSelectors';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet } from 'react-router';
import { initGccApiWeb } from '../../slices/initialization/initializationThunks';

/**
 * Initializes the ApiClient.
 * Only render children components when the ApiClient is initialized.
 */

const ApiProtectedRoute = () => {
  const dispatch = useDispatch();
  const gccApiClientInit = useSelector(getGccApiClientInit) as boolean;

  useEffect(() => {
    if (!gccApiClientInit) {
      dispatch(initGccApiWeb());
    }
  }, [dispatch, gccApiClientInit]);

  if (!gccApiClientInit) {
    return <LoadingPage />;
  }

  return <Outlet />;
};

export default ApiProtectedRoute;
